// -------------------------------------------------------------------------------

// PLEASE DO NOT EDIT THIS FILE, IT IS GENERATED AND WILL BE OVERWRITTEN:
// https://github.com/ccxt/ccxt/blob/master/CONTRIBUTING.md#how-to-contribute-code

// -------------------------------------------------------------------------------

import { implicitReturnType } from '../base/types.js';
import { Exchange as _Exchange } from '../base/Exchange.js';

interface Exchange {
    publicGetInfo (params?: {}): Promise<implicitReturnType>;
    publicGetInfoPrices (params?: {}): Promise<implicitReturnType>;
    publicGetKline (params?: {}): Promise<implicitReturnType>;
    publicGetKlineMark (params?: {}): Promise<implicitReturnType>;
    publicGetBook (params?: {}): Promise<implicitReturnType>;
    publicGetTrades (params?: {}): Promise<implicitReturnType>;
    publicGetFundingRateHistory (params?: {}): Promise<implicitReturnType>;
    publicGetAccount (params?: {}): Promise<implicitReturnType>;
    publicGetAccountSettings (params?: {}): Promise<implicitReturnType>;
    publicGetPositions (params?: {}): Promise<implicitReturnType>;
    publicGetTradesHistory (params?: {}): Promise<implicitReturnType>;
    publicGetFundingHistory (params?: {}): Promise<implicitReturnType>;
    publicGetPortfolio (params?: {}): Promise<implicitReturnType>;
    publicGetAccountBalanceHistory (params?: {}): Promise<implicitReturnType>;
    publicGetOrders (params?: {}): Promise<implicitReturnType>;
    publicGetOrdersHistory (params?: {}): Promise<implicitReturnType>;
    publicGetOrdersHistoryById (params?: {}): Promise<implicitReturnType>;
    publicGetAccountBuilderCodesApprovals (params?: {}): Promise<implicitReturnType>;
    privatePostAccountLeverage (params?: {}): Promise<implicitReturnType>;
    privatePostAccountMargin (params?: {}): Promise<implicitReturnType>;
    privatePostAccountWithdraw (params?: {}): Promise<implicitReturnType>;
    privatePostAccountSubaccountCreate (params?: {}): Promise<implicitReturnType>;
    privatePostAccountSubaccountList (params?: {}): Promise<implicitReturnType>;
    privatePostAccountSubaccountTransfer (params?: {}): Promise<implicitReturnType>;
    privatePostOrdersCreate (params?: {}): Promise<implicitReturnType>;
    privatePostOrdersCreateMarket (params?: {}): Promise<implicitReturnType>;
    privatePostOrdersStopCreate (params?: {}): Promise<implicitReturnType>;
    privatePostPositionsTpsl (params?: {}): Promise<implicitReturnType>;
    privatePostOrdersCancel (params?: {}): Promise<implicitReturnType>;
    privatePostOrdersCancelAll (params?: {}): Promise<implicitReturnType>;
    privatePostOrdersStopCancel (params?: {}): Promise<implicitReturnType>;
    privatePostOrdersEdit (params?: {}): Promise<implicitReturnType>;
    privatePostOrdersBatch (params?: {}): Promise<implicitReturnType>;
    privatePostAccountBuilderCodesApprove (params?: {}): Promise<implicitReturnType>;
    privatePostAccountBuilderCodesRevoke (params?: {}): Promise<implicitReturnType>;
    privatePostAgentBind (params?: {}): Promise<implicitReturnType>;
    privatePostAccountApiKeysCreate (params?: {}): Promise<implicitReturnType>;
    privatePostAccountApiKeysRevoke (params?: {}): Promise<implicitReturnType>;
    privatePostAccountApiKeys (params?: {}): Promise<implicitReturnType>;
}
abstract class Exchange extends _Exchange {}

export default Exchange
